const backendColors = {
  ms: 'rgb(48, 133, 194)',
  pim: 'rgb(190, 81, 130)',
  airchef: 'rgb(141, 34, 69)',
};

const backendNames = {
  ms: 'MSGRAPH',
  pim: 'PIM',
  airchef: 'AirChef',
};

const methods = {
  get: 'rgb(56, 155, 38)',
  post: 'rgb(199, 110, 21)',
  put: 'rgb(255, 221, 3)',
  patch: 'rgb(84, 192, 254)',
  delete: 'rgb(255, 0, 0)',
  ws: 'rgb(210, 83, 153)',
};

function getStatusColor(status?: number) {
  const first = Math.floor((status ?? 200) / 100);
  switch (first) {
    case 3:
      return 'rgb(50, 111, 180)';
    case 4:
      return 'rgb(211, 108, 4)';
    case 5:
      return 'rgb(199, 23, 23)';
    default:
      return 'rgb(44, 158, 44)';
  }
}

export function logApi(
  backend: 'ms' | 'pim' | 'airchef',
  message: string,
  method?: string,
  isResponse = false,
  status?: number,
) {
  const hasMethod = !!method;
  const hasStatus = status !== undefined;
  const css = [
    `color:white;background-color:${backendColors[backend]};padding: 2px 4px;border-radius: 4px;display:inline-block;`,
    'color:inherit;background-color:inherit;',
    (isResponse ? 'color:rgb(149, 187, 252)' : 'color:rgb(202, 113, 10)') +
      ';font-size:1.5em;display:inline-block;margin-top:-0.25em;',
    'color:inherit;background-color:inherit;font-size:inherit;',
    // @ts-expect-error could be anything
    `color:${methods[hasMethod ? method.toLocaleLowerCase() : 'get']};`,
    'color:inherit;background-color:inherit;',
    `background-color:${getStatusColor(status)};color:white;padding: 1px 2px; border-radius: 2px;display:inline-block;`,
    'color:inherit;background-color:inherit;',
  ];

  console.log(
    `%c${backendNames[backend]}%c %c${isResponse ? '\u2190' : '\u2192'}%c${hasMethod ? ` %c${method.toLocaleUpperCase()}%c` : '%c%c'}${hasStatus ? ` %c${status}%c` : '%c%c'} ${message}`,
    ...css,
  );
}
